import { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";
import { Navbar, Nav, Form, Container } from "react-bootstrap";
import { Badge, Input, Grid, Menu, Dropdown, Col, Avatar } from "antd";

import Button from "antd-button-color";

import "./style.css";
import Login from "./Auth/Login";
import MobileMenu from "./MobileMenu";
import Register from "./Auth/Register";
import ExtraAuth from "./Auth/ExtraAuth";
// import * as action from "store/actions";

const LogoFull = "/assets/img/logo-full.png";
const LogoOnly = "/assets/img/logo-only.png";

const { useBreakpoint } = Grid;
const formExtraAuth = { visible: false, type: "" };

const cartMenu = ({ router }) => (
  <Menu className="d-none d-lg-block">
    <Menu.ItemGroup
      title={
        <>
          <b className="text-dark">Keranjang (8)</b>
          <span
            tabIndex={0}
            role="button"
            onClick={() => router.push("/cart")}
            onKeyUp={() => {}}
            className="view-all-text-navbar p-0 hover-pointer"
          >
            Lihat Sekarang
          </span>
        </>
      }
    />
    <Menu.Divider />
    <Menu.ItemGroup className="cart-item-navbar">
      {[...Array(10)].map((x) => (
        <Menu.Item key={x}>
          <Col span={24}>
            <div className="d-flex">
              <img
                alt="cart-item"
                className="me-3 cart-item-img sm align-self-center"
                src="/assets/img/products/1630652431593.jpeg"
              />
              <div>
                <h5 className="mt-0 mb-1 fs-12-s fs-14 text-truncate item-nav-title">
                  Vitra .03 chair black W44*D52*H79 SH42 cm
                </h5>
                <h5 className="my-0 fs-12-s fs-12 font-weight-bold cart-item-price">Rp. 300.000</h5>
                <p className="fs-12-s fs-12 text-black-50 mb-0 ls-n1">5 pcs</p>
              </div>
            </div>
          </Col>
        </Menu.Item>
      ))}
    </Menu.ItemGroup>
  </Menu>
);

const accountMenu = ({ router }) => (
  <Menu className="d-none d-lg-block">
    <Menu.Item onClick={() => router.push("/account/profile")}>
      <span className="text-decoration-none">Profil</span>
    </Menu.Item>

    <Menu.Item>
      <span className="text-decoration-none">Keluar</span>
    </Menu.Item>
  </Menu>
);

const HeaderContainer = () => {
  const history = useHistory();
  const screens = useBreakpoint();

  const user = useSelector((state) => state.auth.user);

  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showExtraAuth, setShowExtraAuth] = useState(formExtraAuth);

  const showRegisterHandler = () => {
    setShowLogin(false);
    setShowRegister(true);
    setShowMobileMenu(false);
    setShowExtraAuth(formExtraAuth);
  };

  const showLoginHandler = () => {
    setShowLogin(true);
    setShowRegister(false);
    setShowMobileMenu(false);
    setShowExtraAuth(formExtraAuth);
  };

  const showExtraAuthHandler = (type) => {
    setShowLogin(false);
    setShowRegister(false);
    setShowMobileMenu(false);
    setShowExtraAuth({ visible: true, type });
  };

  const showMobileMenuHandler = () => {
    setShowMobileMenu(true);
  };

  return (
    <>
      <Navbar
        bg="light"
        expand="lg"
        fixed="top"
        variant="light"
        expanded={false}
        className="bg-white py-2 navbar-container"
      >
        <Container className="container-navbar">
          <Navbar.Brand href="/">
            <img
              alt="logo"
              width={screens.xs ? "44" : "180"}
              src={screens.xs ? LogoOnly : LogoFull}
            />
          </Navbar.Brand>

          <Navbar.Toggle
            onClick={() => history.push("/cart")}
            className="border-0 ml-auto d-lg-none navbar-icon-toggle"
          >
            <Badge count={8} size="small" className="nav-notification">
              <i className="far fa-shopping-cart fa-lg" />
            </Badge>
          </Navbar.Toggle>
          <Navbar.Toggle
            onClick={() => history.push("/wishlist")}
            className="border-0 mx-2 ps-1 d-lg-none navbar-icon-toggle"
          >
            <Badge count={3} size="small" className="nav-notification">
              <i className="far fa-heart fa-lg" />
            </Badge>
          </Navbar.Toggle>

          <Navbar.Toggle
            className="border-0 px-2 navbar-icon-toggle"
            onClick={showMobileMenuHandler}
          >
            <i className="far fa-bars" />
          </Navbar.Toggle>

          <Navbar.Collapse id="navbar-nav">
            <Nav className="ms-auto w-100">
              <Form inline className="mx-lg-2 w-100 align-self-lg-center">
                <Input
                  className="w-100"
                  prefix={<SearchOutlined className="text-dark me-1" />}
                  placeholder="Cari disini..."
                />
              </Form>

              <Nav.Link onClick={() => history.push("/")}>Home</Nav.Link>
              <Nav.Link onClick={() => history.push("/products")}>Katalog</Nav.Link>

              <Dropdown
                arrow
                trigger={["hover"]}
                overlay={cartMenu({ router: history })}
                placement="bottomCenter"
                overlayClassName="overlay-nav-notification"
              >
                <Nav.Link
                  className="ms-2 d-none d-lg-block align-self-center"
                  onClick={() => history.push("/cart")}
                >
                  <Badge count={8} size="small" className="nav-notification">
                    <i className="far fa-shopping-cart fs-18 text-dark" />
                  </Badge>
                </Nav.Link>
              </Dropdown>

              <Nav.Link
                className="ms-2 me-1 d-none d-lg-block align-self-center"
                onClick={() => history.push("/account/wishlist")}
              >
                <Badge count={8} size="small" className="nav-notification">
                  <i className="far fa-heart fs-18 text-dark" />
                </Badge>
              </Nav.Link>

              <span className="border-end mx-2" />

              {user ? (
                <Dropdown overlay={accountMenu({ router: history })} placement="bottomRight">
                  <div
                    className="align-middle user-select-none hover-pointer text-truncate"
                    style={{ width: 250 }}
                  >
                    <Avatar size="large" src={user && user.avatar} />
                    <span className="ps-2 align-middle text-capitalize">{user.username}</span>
                  </div>
                </Dropdown>
              ) : (
                <>
                  <Nav.Item
                    id="id-btn-login"
                    className="me-2 align-self-center d-none d-lg-block m-l-4"
                  >
                    <Button ghost type="dark" onClick={() => setShowLogin(true)}>
                      Masuk
                    </Button>
                  </Nav.Item>
                  <Nav.Item className="align-self-center d-none d-lg-block">
                    <Button type="dark" onClick={() => setShowRegister(true)}>
                      Daftar
                    </Button>
                  </Nav.Item>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Login
        visible={showLogin}
        onClose={() => setShowLogin(false)}
        switchHandler={showRegisterHandler}
        extraAuthHandler={showExtraAuthHandler}
      />
      <Register
        visible={showRegister}
        switchHandler={showLoginHandler}
        onClose={() => setShowRegister(false)}
      />
      <ExtraAuth
        type={showExtraAuth.type}
        visible={showExtraAuth.visible}
        switchHandler={showRegisterHandler}
        onClose={() => setShowExtraAuth(formExtraAuth)}
      />
      <MobileMenu
        visible={showMobileMenu}
        showLoginHandler={showLoginHandler}
        onClose={() => setShowMobileMenu(false)}
        showRegisterHandler={showRegisterHandler}
      />
    </>
  );
};

export default HeaderContainer;
